import React, { useState } from "react";
import { resolveAssetUrl } from "../../utils/resolveAssetUrl";

export default function P2PTeamLogo({ url, name, size = 36, sizeFromCss = false, className = "" }) {
  const src = resolveAssetUrl(url);
  const initial = (name || "?").charAt(0).toUpperCase();
  const [failed, setFailed] = useState(false);
  const style = sizeFromCss
    ? { width: "var(--ap2p-logo-size, 40px)", height: "var(--ap2p-logo-size, 40px)" }
    : { width: size, height: size };

  if (src && !failed) {
    return (
      <img
        src={src}
        alt=""
        className={`ap2p-team-logo${className ? ` ${className}` : ""}`}
        style={style}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span
      className={`ap2p-team-logo ap2p-team-logo-fallback${className ? ` ${className}` : ""}`}
      style={style}
      aria-hidden
    >
      {initial}
    </span>
  );
}
